import { OrganicEventSearchFiltersApiPayload } from '../../../../api/searchOrganicEvents';
import { INITIAL_QUERY } from '../../../../context/search';

function getTagWithSubcategoryPreference(
    tags: OrganicEventSearchFiltersApiPayload['tags'] = [''],
) {
    const subcategoryTag = tags.find((tag: string) =>
        tag.includes('EventbriteSubCategory'),
    );

    if (subcategoryTag) return subcategoryTag;

    return (
        tags.find((tag: string) => tag.includes('EventbriteCategory')) || 'tag'
    );
}

type ActiveTag = string | 'tag';
type LocationTag = string | 'online' | 'location';

export type CategoryBrowseEventsQueryKey = [
    'category-browse',
    'events',
    ActiveTag,
    LocationTag,
    OrganicEventSearchFiltersApiPayload,
];

export function getCategoryBrowseEventsQueryKey(
    eventSearch: OrganicEventSearchFiltersApiPayload,
): CategoryBrowseEventsQueryKey {
    const normalizedEventSearch: OrganicEventSearchFiltersApiPayload = {
        ...INITIAL_QUERY,
        ...eventSearch,
        dates:
            typeof eventSearch.dates === 'string'
                ? [eventSearch.dates]
                : eventSearch.dates,
    };

    const locationTag = normalizedEventSearch.online_events_only
        ? 'online'
        : eventSearch?.places?.[0] || 'location';
    const activeTag = getTagWithSubcategoryPreference(
        normalizedEventSearch?.tags,
    );

    return [
        'category-browse',
        'events',
        activeTag,
        locationTag,
        normalizedEventSearch,
    ];
}
